// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EquityA_thecomp__hD9IS"};